var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-dialog event-dialog",staticStyle:{"width":"100% !important","max-width":"100% !important"}},[(_vm.rawEvent)?_c('CreateEventForm',{attrs:{"isEdit":true,"isPage":true,"rawEventEdit":_vm.rawEvent,"origEvent":_vm.origEvent}}):_vm._e(),(!_vm.rawEvent)?_c('spinner'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }